import { GetTiposInstalacionParams, getTiposInstalacion } from "@/shared/actions/erp";
import { TipoInstalacion } from "@/shared/interfaces";
import { create } from "zustand";

interface TypeInstalationState {
  typInstalation: TipoInstalacion[];

  isLoading: boolean;

  isLoadingTypeInstalation: false,

  getTypeInstalation: (params?: GetTiposInstalacionParams) => Promise<void>;
}

export const useTypeInstalation = create<TypeInstalationState>(
  set => ({
    typInstalation: [],
    isLoading: false,
    isLoadingTypeInstalation: false,
    getTypeInstalation: async params => {
      set({ isLoading: false, isLoadingTypeInstalation: false });
      const res = await getTiposInstalacion(params);

      set({
        typInstalation: res.data.data,
        isLoading: false,
        isLoadingTypeInstalation: false
      });
    }
  })
)